module.exports = new __parcel__URL__("bonsai.5148b146.splat").toString();